const MULTIPLIER = 1664525;
const INCREMENT = 1013904223;

export class SeededRandomGenerator {
  private seed: number;

  constructor(seed = 1) {
    /**
     * bitshift right to make sure number is always positive
     */
    this.seed = seed >>> 0;
  }

  /**
   * Returns a random number between 0 and 1.
   */
  public next(): number {
    /**
     * Linear congruential generator: https://en.wikipedia.org/wiki/Linear_congruential_generator
     */
    this.seed = (this.seed * MULTIPLIER + INCREMENT) >>> 0;

    // map to between 0 and 1, essentially forcing the number to a 32bit unsigned integer
    // 0x100000000 is 2^32
    return this.seed / 0x100000000;
  }
}
